<template>
    <div>
      <TopBar />
      <el-container>
        <el-aside width="200px">
          <SideBar />
        </el-aside>
        <el-main>
          <el-row :gutter="20">
            <!-- 左侧教师信息 -->
            <el-col :span="16">
              <div class="teacher-profile">
                <div class="teacher-info">
                  <!-- 头像和基本信息 -->
                  <div class="teacher-header">
                    <div class="teacher-image">
                      <img :src="teacher.image" alt="Teacher Avatar" />
                    </div>
                    <div class="teacher-details">
                      <p class="username">
                        用户名：{{ teacher.username }}
                        <span class="auth-status">
                          实名认证：
                          <span class="auth-verified">已认证</span>
                        </span>
                        <a href="#" class="modify-link" @click="openEditModal('username')">修改</a>
                      </p>
                      <p class="account-info">
                        账号ID：{{ teacher.accountId }}
                        <span class="separator">·</span>
                        手机号码：{{ teacher.phone }}
                        <a href="#" class="modify-link" @click="openEditModal('phone')">修改</a>
                      </p>
                      <p class="teacher-title">职称：{{ teacher.title }}</p>
                    </div>
                  </div>
                </div>
  
                <!-- 基本信息 -->
                <div class="teacher-info-details">
                  <div class="section">
                    <h4 class="section-title">所属学校</h4>
                    <p>{{ teacher.school }}</p>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">邮箱</h4>
                    <p>{{ teacher.email }}</p>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">微信账号</h4>
                    <p>{{ teacher.wechat }}</p>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">QQ账号</h4>
                    <p>{{ teacher.qq }}</p>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">个人简介</h4>
                    <p>{{ teacher.bio }}</p>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">主讲课程</h4>
                    <div class="section-content courses">
                      <span v-for="(course, index) in teacher.courses" :key="index" class="course-item">{{ course }}</span>
                    </div>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">科研项目</h4>
                    <ul class="section-content">
                      <li v-for="(project, index) in teacher.researchProjects" :key="index">{{ project }}</li>
                    </ul>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">申请专利</h4>
                    <ul class="section-content">
                      <li v-for="(patent, index) in teacher.patents" :key="index">{{ patent }}</li>
                    </ul>
                  </div>
  
                  <div class="section">
                    <h4 class="section-title">发表论文</h4>
                    <ul class="section-content">
                      <li v-for="(paper, index) in teacher.papers" :key="index">{{ paper }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
  
      <!-- 修改信息的弹出框 -->
      <el-dialog title="修改信息" :visible.sync="isEditModalOpen">
        <el-form>
          <el-form-item :label="`修改 ${editField} 信息`">
            <el-input v-model="editValue" :placeholder="`请输入新的${editField}`" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeEditModal">取消</el-button>
          <el-button type="primary" @click="saveEdit">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import SideBar from '../components/SideBar.vue';
  import TopBar from '../components/TopBar.vue';
  
  export default {
    name: 'TeacherProfile',
    components: { SideBar, TopBar },
    data() {
      return {
        teacher: {
          image: '/images/teacher.jpg',
          username: 'dsfuis',
          accountId: '2489372598',
          phone: '13812345678',
          title: '博士，副教授',
          school: '华中科技大学 计算机学院',
          email: 'teacher@example.com',
          wechat: 'wechatID123',
          qq: '123456789',
          bio: '1995年于华中科技大学获学士学位，1999年于华中科技大学获硕士学位，2011年毕业于武汉大学计算机学院，获得“通信与信息系统”博士学位。',
          courses: [
            '《接口技术》',
            '《计算机组成原理》',
            '《数字逻辑》',
            '《自动控制原理》',
            '《单片机运用技术》',
            '《计算机基础》'
          ],
          researchProjects: [
            '主持国家自然科学基金1项（2013-2015）',
            '主持武汉市科技计划项目1项（2013-2014）',
            '主持华中师范大学自主科研项目2项（2011-2012）、（2013-2014）',
            '主持企业横向课题3项'
          ],
          patents: [
            '申请国家发明专利6项，其中3项已经获得授权'
          ],
          papers: [
            '近五年来，以第一作者在国际重要的学术会议、权威期刊和核心期刊公开发表论文30多篇，其中多篇发表于《计算机学报》、《电子学报》及SCI收录期刊'
          ]
        },
        isEditModalOpen: false,
        editField: '',
        editValue: ''
      };
    },
    methods: {
      openEditModal(field) {
        this.editField = field;
        this.editValue = this.teacher[field];
        this.isEditModalOpen = true;
      },
      closeEditModal() {
        this.isEditModalOpen = false;
      },
      saveEdit() {
        this.teacher[this.editField] = this.editValue;
        this.closeEditModal();
      }
    }
  };
  </script>
  
  <style scoped>
  .teacher-profile {
    padding: 20px;
    background-color: #fff;
  }
  
  .teacher-info .teacher-header {
    display: flex;
  }
  
  .teacher-info .teacher-image {
    margin-right: 20px;
  }
  
  .teacher-info .teacher-image img {
    border-radius: 50%;
  }
  
  .teacher-info .teacher-details p {
    margin: 5px 0;
  }
  
  .section-title {
    font-size: 16px;
    font-weight: bold;
  }
  
  .modify-link {
    color: #409eff;
    cursor: pointer;
  }
  </style>
  